import { t } from './i18n'

// The backend seeds every account's personal workspace with this exact name
// (internal/api/auth_handler.go and github_auth.go). It's a default label, not
// user data, so we localize it at display time. If the user renamed their
// workspace (e.g. via onboarding), name !== this sentinel and we show their name.
const PERSONAL_DEFAULT_NAME = 'Mon espace'

// Display name for a workspace: the localized "personal workspace" label when
// the name is still the untouched default, otherwise the stored name.
export function workspaceDisplayName(name?: string | null): string {
  if (name === PERSONAL_DEFAULT_NAME) return t('personalWorkspace')
  return name ?? ''
}

// Absolute URL for a workspace's subdomain on the current host's parent domain
// (works in dev lvh.me and prod). Navigating here logs the user into that
// workspace via the membership-aware /api/auth/refresh bootstrap.
export function workspaceUrl(slug: string): string {
  const host = window.location.host // {slug}.{domain}[:port]
  const firstDot = host.indexOf('.')
  const parent = firstDot >= 0 ? host.slice(firstDot + 1) : host
  return `${window.location.protocol}//${slug}.${parent}/`
}
